class RelatedProducts {

    constructor(el) {
        this.el = el;
        this.$el = jQuery(el);
        this.$slider = jQuery('.related-products-slides', this.el);
        this.$controls = jQuery('.related-products-controls', this.el);

        this.defaultSlickOptions = {
            lazyLoad: 'progressive',
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            appendDots: this.$controls,
            // appendArrows: this.$controls,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        dots: true
                    }

                }, {

                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        dots: true
                    }

                }, {

                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                    }

                }]
        };
        this.$slider.slick(this.defaultSlickOptions);

    }


    static initializeStatic() {

        jQuery('.related-products').each((index, el) => {
            const blockId = `wpshopify_initial_RelatedProducts_${index}`;
            window.WPShopify.blockInstances[blockId] = {
                el: el,
                id: blockId,
                blockInitFunctionName: 'RelatedProducts',
                instance: RelatedProducts.initializeBlock(el)
            };
        });
    }

    static initializeBlock(el){
       return new RelatedProducts(el);
    }

}

window.WPShopify.blocksInits['RelatedProducts'] = RelatedProducts.initializeBlock;

RelatedProducts.initializeStatic();
